// Author yjb
// Date 2021-11-13 20:42:08

import * as model from "@/model/em/statusCollection/ImfSicEquipmentInfoIseiModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.ImfSicEquipmentInfoIsei(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_STATUSCOLLECTION_URL,
    })
    .buildStore()
